<template>
  <slot />
</template>
<script>
export default {
  props: ["class", "name"]
};
</script>
